import { render } from "./Unwrapped.vue?vue&type=template&id=095b6314"
import script from "./Unwrapped.vue?vue&type=script&lang=js"
export * from "./Unwrapped.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__